@if (areTestStatsAvailable$ | async) {
  <div>
    @if (isAiAssistantEnabled$ | async) {
      <div style="display: flex; justify-content: flex-end">
        <button
          matSuffix
          mat-icon-button
          color="primary"
          class="icon button"
          (click)="onAiAssistantClicked(currentStats)"
        >
          <span class="material-symbols-outlined">auto_awesome</span>
        </button>
      </div>
    }
    <div>
      @if (isSimpleStatsView$ | async) {
        <div class="stats-container">
          @for (statsItem of stats$ | async; track statsItem; let i = $index) {
            <div class="stat-item">
              <atlas-simple-stats-page
                [value]="statsItem.value"
                [name]="statsItem.name"
              ></atlas-simple-stats-page>
            </div>
          }
        </div>
      } @else {
        <div class="stats-content">
          <atlas-standard-stats-page
            [queryItem]="stats$ | async"
          ></atlas-standard-stats-page>
        </div>
      }
    </div>
  </div>
}
